<template>
  <div class="profile">
    <p>{{ $t('driver_onboarding.step_progress_bar.step', { num: $route.meta.step_id }) }}</p>
    <h1>{{ $t('driver_onboarding.profile.title') }}</h1>

    <div class="supplier-info">
      <div class="general-info">
        <div class="title-form">
          <h5>{{ $t('driver_onboarding.profile.general.title') }}</h5>
        </div>
        <General/>
      </div>

      <div class="general-info">
        <div class="title-form">
          <h5>{{ $t('driver_onboarding.profile.identity.title') }}</h5>
        </div>

        <IDCard/>
        <div class="content-form">
          <p class="title-section">{{ $t('driver_onboarding.profile.address.id_address') }}</p>
          <Address fieldName="id_address" />
        </div>

        <hr />
        <div class="content-form selection-address">
          <div class="is-flex">
            <p class="title-section">{{ $t('driver_onboarding.profile.address.family_reg_address') }}</p>
            <div class="field">
              <b-checkbox
              class="useIDAddress"
                @input="onChangeUseIdAddress('family_reg_address')"
                v-model="useIdAddress.family_reg_address"
              >{{ $t('driver_onboarding.profile.address.same_id_address') }}</b-checkbox>
            </div>
          </div>
          <Address fieldName="family_reg_address" :requireDetail="true" v-if="!useIdAddress.family_reg_address" />
        </div>
        <hr />
        <div class="content-form selection-address">
          <div class="is-flex">
            <p class="title-section">{{ $t('driver_onboarding.profile.address.current_address') }}</p>
            <div class="field">
              <b-checkbox
               class="useIDAddress"
                @input="onChangeUseIdAddress('current_address')"
                v-model="useIdAddress.current_address"
              >{{ $t('driver_onboarding.profile.address.same_id_address') }}</b-checkbox>
            </div>
          </div>
          <Address fieldName="current_address" :requireDetail="true" v-if="!useIdAddress.current_address" />
        </div>
      </div>

      <div class="general-info">
        <div class="title-form">
          <h5>{{ $t('driver_onboarding.profile.vehicle.title') }}</h5>
        </div>
        <Vehicle />
      </div>

      <div class="general-info">
        <div class="title-form">
          <h5>{{ $t('driver_onboarding.profile.relative.title') }}</h5>
        </div>
        <Relative />
      </div>
    </div>
    <b-tooltip
      :label="isValidFormData.message"
      position="is-right"
      size="is-large"
      multilined
      type="is-dark"
      class="tooltip"
    >
      <b-button 
        @click.prevent="onSubmit"
        :loading="spinLoading"
        :disabled="!isValidFormData.value"
      >Tiếp tục</b-button>
    </b-tooltip>
  </div>
</template>
<script>
import General from "./components/General";
import IDCard from "./components/IDCard";
import Address from "./components/Address";
import Vehicle from "./components/Vehicle";
import Relative from "./components/Relative";
import { mapGetters } from "vuex";

export default {
  components: {
    General,
    IDCard,
    Address,
    Vehicle,
    Relative
  },
  computed: {
    ...mapGetters(["supplierToken", "supplierProfile", "formData", "isValidFormData"]),  
  },
  data() {
    return {
      useIdAddress: {
        current_address: false,
        family_reg_address: false
      },

      spinLoading: false,
    };
  },
  methods: {
    onChangeUseIdAddress (field) {
      const { id_address, current_address, family_reg_address } = this.formData
      if (id_address) {
        let formData = {
          id_address,
          current_address,
          family_reg_address,
        }

        formData[field] = this.useIdAddress[field] ? id_address : formData[field]
        this.$store.dispatch('setAddressProfile', formData)
      }      
    },

    onSubmit() {
      this.spinLoading = true;


      if(this.useIdAddress.current_address){
        this.formData.current_address = this.formData.id_address
      }
      if(this.useIdAddress.family_reg_address){
        this.formData.family_reg_address = this.formData.id_address
      }

      let data = {
        token: this.supplierToken,
        name: this.formData.fullname,
        plate_number: this.formData.plate_number,
        id_number: this.formData.id_number,
        extra: JSON.stringify(this.formData)
      };
      this.$store
        .dispatch("updateProfile", data)
        .then(response => {

          if (response.status === 200) {
            this.spinLoading = false;

            this.$router.push({ name: "training" });
          }
        })
        .catch(error => {
          this.spinLoading = false;

          switch(error.status) {
            case 404:
               this.$buefy.notification.open({
                message: this.$t("driver_onboarding.auth.token_expire"),
                type: "is-danger",
                duration: 3000,
                position: "is-bottom"
              });
              this.$router.push({ name: "signin" });
              break;
            case 409: 
              if(error.data.title === 'ID number existed'){
                this.$buefy.notification.open({
                  message: this.$t('driver_onboarding.profile.error_msg.id_number_existed'),
                  type: "is-danger",
                  duration: 3000,
                  position: "is-bottom"
                });
              }else{
                this.$buefy.notification.open({
                  message: error.data.title,
                  type: "is-danger",
                  duration: 3000,
                  position: "is-bottom"
                });
              }
              break;
            case 406: 
              this.$buefy.notification.open({
                message: this.$t('driver_onboarding.profile.error_msg.email_not_valid'),
                type: "is-danger",
                duration: 3000,
                position: "is-bottom"
              });
              break;
             case 500: 
              this.$buefy.notification.open({
                message: this.$t('driver_onboarding.profile.error_msg.id_number_existed'),
                type: "is-danger",
                duration: 3000,
                position: "is-bottom"
              });
              break;

            default : 
              this.$buefy.notification.open({
                message:`Lỗi ${error.status}: ${error.data.description}`,
                type: "is-danger",
                duration: 3000,
                position: "is-bottom"
              });
          }

          // if(error.status === 404) {
          //   this.$buefy.notification.open({
          //     message: this.$t("driver_onboarding.auth.token_expire"),
          //     type: "is-danger",
          //     duration: 3000,
          //     position: "is-bottom"
          //   });
          //   this.$router.push({ name: "signin" });
          // }else{
          //   switch(error.status){
          //     case 409: 
          //       if(error.data.title === 'ID number existed'){
          //         this.$buefy.notification.open({
          //           message: this.$t('driver_onboarding.profile.error_msg.id_number_existed'),
          //           type: "is-danger",
          //           duration: 3000,
          //           position: "is-bottom"
          //         });
          //       }else{
          //         this.$buefy.notification.open({
          //           message: error.data.title,
          //           type: "is-danger",
          //           duration: 3000,
          //           position: "is-bottom"
          //         });
          //       }
          //       break;
          //     case 406: 
          //       this.$buefy.notification.open({
          //         message: this.$t('driver_onboarding.profile.error_msg.email_not_valid'),
          //         type: "is-danger",
          //         duration: 3000,
          //         position: "is-bottom"
          //       });
          //       break;
          //     case 500: 
          //       this.$buefy.notification.open({
          //         message: this.$t('driver_onboarding.profile.error_msg.id_number_existed'),
          //         type: "is-danger",
          //         duration: 3000,
          //         position: "is-bottom"
          //       });
          //       break;
          //     default : 
          //       this.$buefy.notification.open({
          //         message:`Lỗi ${error.status}: ${error.data.description}`,
          //         type: "is-danger",
          //         duration: 3000,
          //         position: "is-bottom"
          //       });
          //   }
          // }
        });

      this.$gtag('event',this.$trackingEvents.EVENTS.SUBMIT_DOCUMENT, {'event_category' : this.$route.path})

    }
  },
  created() {
    const profile = this.supplierProfile
    if (profile && profile.extra) {
      const formData = {
        fullname: profile.name,
        gender: profile.extra.gender,
        date_of_birth: profile.extra.date_of_birth,
        marriage_status: profile.extra.marriage_status,

        id_number: profile.extra.id_number,
        id_issue_date: profile.extra.id_issue_date,
        id_issue_place: profile.extra.id_issue_place,
        id_native_place: profile.extra.id_native_place,

        id_address: profile.extra.id_address,
        current_address: profile.extra.current_address,
        family_reg_address: profile.extra.family_reg_address,

        vehicle_type: profile.extra.vehicle_type,
        driving_license: profile.extra.driving_license,
        plate_number: profile.extra.plate_number,

        relatives: profile.extra.relatives,
      }
      this.$store.dispatch('setProfileFormData', formData)
      this.$store.dispatch('setRelativeProfile', formData.relatives)

      this.useIdAddress.current_address = formData.current_address === formData.id_address
      this.useIdAddress.family_reg_address = formData.family_reg_address === formData.id_address
    }    
  },
  mounted(){
    if(this.supplierProfile && this.supplierProfile.extra && (this.supplierProfile.extra.is_valid || this.supplierProfile.extra.is_contracted)){
      this.$router.push({name : 'training'})
    }
  }
};
</script>
<style lang="scss" scoped>
.profile {
  p:first-child {
    color: #bcbcbc;
    font-size: 16px;
    margin-bottom: 4px;
    font-weight: 500;
  }
  h1 {
    margin: 0 0 40px 0;
    color: #1a1a1a;
  }

  .supplier-info {
    max-width: 550px;
    .general-info {
      border: 1px solid #142246;
      border-radius: 4px;
      margin-bottom: 16px;

      hr {
        margin: 0;
      }
      .title-form {
        background-color: #142246;
        padding: 10px 20px;

        h5 {
          margin: 0;
          color: #fff;
        }
      }
      .content-form {
        padding: 20px 20px 15px;
        border-radius: 4px;
        background-color:#fff;

        p.title-section {
          margin-bottom: 8px;
          font-size: 14px;
          color: #1a1a1a;
          font-weight: 400;
        }

        .field.column {
          margin-bottom: 0;
          padding: 8px;
        }
      }
      .content-form.selection-address {
        .is-flex {
          justify-content: space-between;
        }
        .form-fields {
          margin-top: 15px;
        }
      }
    }
  }

  button {
    margin-top: 32px;
    margin-bottom: 32px;
    background-color: #ff8200;
    color: #fff;
    border-color: inherit;
    border-radius: 4px;
    width: 150px;
    height: 48px;
    font-weight: 500;
  }
}
</style>
<style lang="scss">
.tooltip {
  background-color: none !important;
}
.useIDAddress {
  font-size: 14px;
  color: #ff8200;
  font-weight: 500;

  &:hover{
    color: #ff8200;
  }
}
</style>
